import { render } from "./ScanInventory.vue?vue&type=template&id=6f6a453c&scoped=true"
import script from "./ScanInventory.vue?vue&type=script&lang=js"
export * from "./ScanInventory.vue?vue&type=script&lang=js"

import "./ScanInventory.vue?vue&type=style&index=0&id=6f6a453c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6a453c"]])

export default __exports__